module.exports = __webpack_public_path__ + "static/media/arion.da1e78fe.png";